/**
 * Admin-wide responsive breakpoint tokens. These are the single source of
 * truth — any `@media` query that wants to behave the same way the
 * `useViewport` hook does should read from this file (or mirror the
 * pixel values) so CSS and JS stay in lock-step.
 *
 * Aligned with Tailwind's default md/lg so tribal mental models port.
 */
export const BREAKPOINTS = {
  /** Below this width the layout renders in "mobile" mode. */
  mobile: 640,
  /** Between mobile and this width is "tablet" mode. */
  tablet: 1024,
  /** Above `tablet` we run the full desktop layout. */
  desktop: 1280,
} as const;

export const MEDIA = {
  /** Mobile-only — below 640px. */
  mobile: `(max-width: ${BREAKPOINTS.mobile - 1}px)`,
  /** Tablet-and-up — 640px+. */
  tabletUp: `(min-width: ${BREAKPOINTS.mobile}px)`,
  /** Tablet-and-down — everything below 1024px (sidebar drawer layout). */
  tabletDown: `(max-width: ${BREAKPOINTS.tablet - 1}px)`,
  /** Desktop-and-up — 1024px+ (sidebar pinned layout). */
  desktopUp: `(min-width: ${BREAKPOINTS.tablet}px)`,
} as const;
